import * as React from 'react'
import { IUserStore } from '../../../store/UserStore'
import { ILayoutStore } from '../../../store/LayoutStore'
import { IResultStore, ResultStore } from '../../../store/ResultStore'
import { IWeekConsumptionStore } from '../../../store/WeekConsumptionStore'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { manRisks, womanRisks, IResultsRisks } from './ResultsRisks'
import { inject } from 'mobx-react'
import CarrouselCard from './CarrouselCard'
import Title from 'src/components/Title/Title'
import Icon from 'src/components/Icon/Icon'

interface IRiskCarrouselProps extends RouteComponentProps {
  UserStore?: IUserStore
  LayoutStore?: ILayoutStore
  ResultStore?: IResultStore
  WeekConsumptionStore?: IWeekConsumptionStore
}

interface IRiskCarrouselState {
  current: number
  showDetails: boolean
}

const riskMapping = {
  H: manRisks,
  F: womanRisks,
}

@inject('UserStore', 'LayoutStore', 'WeekConsumptionStore', 'ResultStore')
class RiskCarrousel extends React.Component<IRiskCarrouselProps, IRiskCarrouselState> {
  public constructor(props) {
    super(props)
    this.state = {
      current: 0,
      showDetails: false,
    }
  }

  public render() {
    const { showDetails } = this.state
    let risks = []
    if (this.props.UserStore.gender !== null) {
      risks = riskMapping[this.props.UserStore!.gender]
    }

    risks = risks.filter((risk: IResultsRisks) => {
      return !!ResultStore[risk.resultField]
    })

    const consumptionDaysCount = this.props.UserStore!.consumptionDays.length

    return (
      <>
        {consumptionDaysCount > 0 && !ResultStore.isInConsumptionMarks && (
          <section className="ResultsRisks">
            <Title subtitle={true}>
              <p>Les risques pour ma santé</p>
            </Title>
            <h3 className="ResultsRisks-title">
              Selon la consommation d’alcool que vous venez d’indiquer, voici les risques que vous
              prenez pour votre santé…
            </h3>
            <div
              className={`ResultsRisks-results${showDetails ? ' ResultsRisks-results--show' : ''}`}
            >
              {risks.map((risk, index) => {
                return (
                  <CarrouselCard risk={risk} key={index} active={this.state.current === index} />
                )
              })}
            </div>
            <div className="ResultsRisks-control">
              {showDetails ? (
                <button
                  className="ResultsRepeatTest-btn ResultsConsumption__btn"
                  onClick={this.hideMoreDetails}
                >
                  Réduire
                  <span>
                    <Icon name="deplierred" />
                  </span>
                </button>
              ) : (
                <button className="ResultsRisks-btn" type="button" onClick={this.showMoreDetails}>
                  Voir les autres risques
                  <span>
                    <Icon name="deplier" />
                  </span>
                </button>
              )}
            </div>
          </section>
        )}
      </>
    )
  }
  private showMoreDetails = () => {
    this.setState({
      showDetails: true,
    })
  }

  private hideMoreDetails = () => {
    this.setState({
      showDetails: false,
    })
  }
}

export default withRouter(RiskCarrousel)



// WEBPACK FOOTER //
// ./src/components/ResultsComponents/ResultsRisks/RiskCarrousel.tsx